import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import styles from './settings.module.css';

// Settings pages
import SettingsPage from "src/legacy/pages/settings/SettingsPage";
import AccountManagement from './accountManagement';
import ProfilePage from './profile';
import NotificationPage from "./notifications";
import UserManagementPage from "src/legacy/pages/settings/userManagement/UserManagementPage";
import UserManagementListContainer from "src/legacy/pages/settings/userManagement/list/UserManagementListContainer";
import UserGroupDetailPage from "src/legacy/pages/settings/userManagement/userGroup/UserGroupDetailPage";
import UserDetailContainer from "src/legacy/pages/settings/userManagement/user/UserDetailContainer";
import UserRoleDetailPage from "src/legacy/pages/settings/userManagement/userRole/UserRoleDetailPage";
import FliteviewSettingsPage from "src/legacy/pages/settings/fliteview/FliteviewSettingsPage";
import HubSettingsPage from "src/legacy/pages/settings/hubSettings/index.jsx";
import CustomFieldContainer from "src/legacy/pages/settings/customFields/CustomFieldContainer";
import PrivacyPolicyControlPage from "src/legacy/pages/settings/privacyPolicyControl/PrivacyPolicyControlPage";
import PrivacyPolicy from "src/legacy/pages/settings/PrivacyPolicy";
import TermsAndConditions from "src/legacy/pages/settings/TermsAndConditions";
import StreamAccessManagementPage from "./streamAccessManagement";
import DistributionListContainer from "src/legacy/pages/settings/distributionLists/DistributionListContainer";
import DataSourcePage from "src/legacy/pages/settings/dataSource/DataSourcePage";
import ContactListDetailsContainer from "src/legacy/pages/settings/distributionLists/details/ContactListDetailsContainer";
import EmailTemplatePage from "src/legacy/pages/settings/emailTemplate/EmailTemplatePage";
import EmailTemplateDetailPage from "src/legacy/pages/settings/emailTemplate/EmailTemplateDetailPage";
import NDATemplatesContainer from "src/legacy/pages/settings/ndaTemplates";
import IntegrationsPage from "src/legacy/pages/settings/integrations/integrations/IntegrationsPage";
import UnsubscribePage from "src/legacy/pages/settings/unsubscribe/UnsubscribePage";

// Integration pages
import LinkedInIntegration from "src/pages/integrations/linkedIn";
import CleverstoryPage from "src/legacy/pages/settings/integrations/integrations/cleverstory/index";
import GmailPage from "src/legacy/pages/settings/integrations/integrations/gmail/GmailPage";
import OutlookPage from "src/legacy/pages/settings/integrations/integrations/outlook/OutlookPage";
import SalesforcePage from "src/legacy/pages/settings/integrations/integrations/salesforce/SalesforcePage";
import SalesforceSandboxPage from "src/legacy/pages/settings/integrations/integrations/salesforceSandbox/SalesforceSandboxPage";
import OutreachPage from "src/legacy/pages/settings/integrations/integrations/outreach/OutreachPage";
import PipedrivePage from "src/legacy/pages/settings/integrations/integrations/pipedrive/PipedrivePage";
import FreshsalesPage from "src/legacy/pages/settings/integrations/integrations/freshsales/FreshsalesPage";
import PardotPage from "src/legacy/pages/settings/integrations/integrations/pardot/PardotPage";
import SlackPage from "src/legacy/pages/settings/integrations/integrations/slack/SlackPage";
import GoogleAnalyticsPage from "src/legacy/pages/settings/integrations/integrations/googleAnalytics/GoogleAnalyticsPage";
import GoogleAnalytics4Page from "src/legacy/pages/settings/integrations/integrations/googleAnalytics4/GoogleAnalytics4Page";
import HubspotPage from "src/legacy/pages/settings/integrations/integrations/hubspot/HubspotPage";
import ZohoPage from "src/legacy/pages/settings/integrations/integrations/zoho/ZohoPage";
import NetsuitePage from "src/legacy/pages/settings/integrations/integrations/netsuite/NetsuitePage";
import MsDynamicsPage from "src/legacy/pages/settings/integrations/integrations/msDynamics/MsDynamicsPage";
import SalesloftPage from "src/legacy/pages/settings/integrations/integrations/salesloft/SalesloftPage";
import SmtpPage from "src/legacy/pages/settings/integrations/integrations/smtp/SmtpPage";
import GoogleTagManagerPage from "src/legacy/pages/settings/integrations/integrations/googleTagManager/GoogleTagManagerPage";
import KlentyPage from "src/legacy/pages/settings/integrations/integrations/klenty/KlentyPage";
import SixSensePage from "src/legacy/pages/settings/integrations/integrations/sixSense/SixSensePage";
import MarketoPage from "src/legacy/pages/settings/integrations/integrations/marketo/MarketoPage";
import IntercomPage from "src/legacy/pages/settings/integrations/integrations/intercom/IntercomPage";
import ExternalScriptPage from "src/legacy/pages/settings/integrations/integrations/externalScript/ExternalScriptPage";
import DriftPage from "src/legacy/pages/settings/integrations/integrations/drift/DriftPage";
import Dashboard from './dashboard';
import CustomFields from './customFields';
import Integrations from './integrations';
import userRoleService from 'src/utils/userRoles.service';
import DataSource from './dataSource';

import { SkillDetailPage, SkillSettingsPage } from "src/pages/coaching/settings/skills";
import ManageUserRoles from './userRole';

const SettingsRoutes: React.FC = () => {
  const isAdmin = userRoleService.isAdmin();
  return (
    <Routes>
      <Route path="/" element={<SettingsPage />}>
        <Route index element={<Navigate to={isAdmin ? "/settings/dashboard" : "/settings/profile"} />} />
        <Route path="/dashboard" element={<Dashboard />} />
        {/* <Route index element={<Navigate to="/settings/profile" />} /> */}
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/notifications" element={<NotificationPage />} />
        <Route
          path="/account-management"
          element={
            isAdmin ? <AccountManagement /> : <Navigate to="/settings/hub-settings" replace />
          }
        />
        <Route path="/user-management" element={<UserManagementPage />}>
          <Route path=":filter" element={<UserManagementListContainer />} />
        </Route>

        <Route path="/user-roles" element={<ManageUserRoles />} />
        <Route path="/user-roles/:id" element={<ManageUserRoles />} />

        <Route
          path="/user-management/group/:id"
          element={<UserGroupDetailPage />}
        />
        <Route
          path="/user-management/user/:id"
          element={<UserDetailContainer />}
        />
        <Route path="/fliteview" element={<FliteviewSettingsPage />} />
        <Route path="/hub-settings" element={<HubSettingsPage />} />
        <Route path="/custom_fields" element={<CustomFields />} />
        <Route
          path="/privacy-policy-control"
          element={<PrivacyPolicyControlPage />}
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route
          path="/stream-access-management"
          element={<StreamAccessManagementPage />}
        />
        <Route
          path="/distribution_lists"
          element={<DistributionListContainer />}
        />
        <Route path="/data-sources" element={<DataSource />} />
        <Route path="/contact_list" element={<ContactListDetailsContainer />} />
        <Route
          path="/contact_list/:id"
          element={<DistributionListContainer />}
        />
        <Route path="/email-template" element={<EmailTemplatePage />} />
        <Route
          path="/email-template/:id"
          element={<EmailTemplateDetailPage />}
        />
        <Route path="/skills" element={<SkillSettingsPage />}>
          <Route path=":id" element={<SkillDetailPage />} />
        </Route>

        <Route path="/nda-templates" element={<NDATemplatesContainer />} />
        <Route path="/nda-templates/:id" element={<NDATemplatesContainer />} />
        <Route path="/integrations" element={<Integrations />} />
      </Route>

      {/* Integration routes outside of the settings layout */}
      <Route path="/integrations/linkedIn" element={<LinkedInIntegration />} />
      <Route path="/integrations/cleverstory" element={<CleverstoryPage />} />
      <Route path="/integrations/gmail" element={<GmailPage />} />
      <Route path="/integrations/outlook" element={<OutlookPage />} />
      <Route path="/integrations/salesforce" element={<SalesforcePage />} />
      <Route path="/integrations/salesforce-sandbox" element={<SalesforceSandboxPage />} />
      <Route path="/integrations/outreach" element={<OutreachPage />} />
      <Route path="/integrations/pipedrive" element={<PipedrivePage />} />
      <Route path="/integrations/freshsales" element={<FreshsalesPage />} />
      <Route path="/integrations/pardot" element={<PardotPage />} />
      <Route path="/integrations/slack" element={<SlackPage />} />
      <Route
        path="/integrations/google-analytics"
        element={<GoogleAnalyticsPage />}
      />
      <Route
        path="/integrations/google-analytics-4"
        element={<GoogleAnalytics4Page />}
      />
      <Route path="/integrations/hubspot" element={<HubspotPage />} />
      <Route path="/integrations/zoho" element={<ZohoPage />} />
      <Route path="/integrations/netsuite" element={<NetsuitePage />} />
      <Route path="/integrations/ms-dynamics" element={<MsDynamicsPage />} />
      <Route path="/integrations/salesloft" element={<SalesloftPage />} />
      <Route path="/integrations/smtp" element={<SmtpPage />} />
      <Route
        path="/integrations/google-tag-manager"
        element={<GoogleTagManagerPage />}
      />
      <Route path="/integrations/klenty" element={<KlentyPage />} />
      <Route path="/integrations/six-sense" element={<SixSensePage />} />
      <Route path="/integrations/marketo" element={<MarketoPage />} />
      <Route path="/integrations/intercom" element={<IntercomPage />} />
      <Route
        path="/integrations/external-script"
        element={<ExternalScriptPage />}
      />
      <Route path="/integrations/driftchat" element={<DriftPage />} />
    </Routes>
  );
};

export default SettingsRoutes;